import React from 'react';
import {Grid, Table, TableBody, TableCell, TableHead, TableRow,} from '@material-ui/core';
import {useEffect, useState} from 'react';
import axios from "../../../api";
import Swal from "sweetalert2";
import CheckIcons from "./CheckIcons";
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables.min.js';


const ListarSenhasComponent = () => {
    //definição de estados da tabela
    const [results, setTableData] = useState([]);
    //busca os dados de historico de senhas
    useEffect(() => {
        async function fetchData() {
            try {
                Swal.fire({
                    title: 'Carregando...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const token = localStorage.getItem('token'); // obter token de autorização

                const response = await axios.get('/senha', {
                    headers: {
                        Authorization: `Bearer ${token}` // adicionar token de autorização no cabeçalho
                    }
                });

                const results = response.data.data;
                if (results != null) {
                    Swal.close();
                    setTableData(results);
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: 'Não há histórico de senhas registradas nesta Unidade, verificar com seu administrador de sistemas.',
                });
            }
        }

        fetchData();
    }, []);


    return (
            <div>
                <br/>
                <Grid item xs={12}>
                    <Table id={'senhas'}>
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>Senha</strong></TableCell>
                                <TableCell><strong>Nome do paciente</strong></TableCell>
                                <TableCell><strong>Aguardando atendimento</strong></TableCell>
                                <TableCell><strong>Horário de chegada</strong></TableCell>
                                <TableCell><strong>Necessidades específicas</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {results.slice(1,4).map((result) => (
                                <TableRow key={result.id}>
                                    <TableCell><strong>{result.senha}</strong></TableCell>
                                    <TableCell>{result.name}</TableCell>
                                    <TableCell ><CheckIcons /></TableCell>
                                    <TableCell>{result.created_at}</TableCell>
                                    <TableCell>{result.tipo_deficiencia === null ? 'Não' : 'Sim'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
            </div>
        );
    };
    export default ListarSenhasComponent;
